import axios from 'axios';
import { apiService } from '@/services/APIService';

const PATH = '/addresses';

export default {
  getPublicAddresses(params) {
    return apiService.get('/public/addresses', params);
  },

  getCoordsByAddress(address) {
    return axios.get(`https://geocode-maps.yandex.ru/1.x/?format=json&geocode=${address}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
  },

  // ADDRESS SPACES

  getEventAddressSpaces(params) {
    return apiService.get('/address-spaces', params);
  },

  getEventAddressSpacesCached(params) {
    return apiService.getCached('/address-spaces', params);
  },

  getEventAddressSpace(id, params) {
    return apiService.get(`/address-spaces/${id}`, params);
  },

  createEventAddressSpace(params) {
    return apiService.post('/address-spaces?expand=images', params);
  },

  updateEventAddressSpace(id, params) {
    return apiService.put(`/address-spaces/${id}?expand=images`, params);
  },

  deleteEventAddressSpace(id) {
    return apiService.delete(`/address-spaces/${id}`);
  },

  attachAddressSpaceImages(id, params) {
    return apiService.post(`/address-spaces/${id}/attach-images?expand=images`, params);
  },

  // from CRUD

  getAll(params) {
    return apiService.get(PATH, params);
  },

  get(id, params) {
    return apiService.get(`${PATH}/${id}`, params);
  },

  create(payload) {
    return apiService.post(PATH, payload);
  },

  update(id, payload) {
    return apiService.put(`${PATH}/${id}`, payload);
  },

  delete(id) {
    return apiService.delete(`${PATH}/${id}`);
  },

  deleteAll(payload) {
    return apiService.delete(PATH, payload);
  },
};
